import { render, staticRenderFns } from "./TariffRate.vue?vue&type=template&id=6e8ad956&"
import script from "./TariffRate.vue?vue&type=script&lang=js&"
export * from "./TariffRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports